module.exports = __webpack_public_path__ + "img/NGN.42eacec3.svg";